import { render, staticRenderFns } from "./FormularioObrigatorioAssinaturaEletronica.vue?vue&type=template&id=5352315e"
import script from "./FormularioObrigatorioAssinaturaEletronica.vue?vue&type=script&lang=js"
export * from "./FormularioObrigatorioAssinaturaEletronica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports